import logger from '../utils/logger';
import api from '../config/api';

const stripePaymentService = {
  async createPaymentLink(planData, userData) {
    try {
  logger.debug('=== STRIPE PAYMENT SERVICE DEBUG ===');
  logger.debug('StripePaymentService - planData:', planData);
  logger.debug('StripePaymentService - userData:', userData);
      
      const requestPayload = {
        planCode: planData.code,
        planName: planData.name,
        amount: planData.amount,
        currency: planData.currency,
        billingInterval: planData.billingInterval,
        customerEmail: userData.email,
        customerName: userData.name,
        returnUrl: `${window.location.origin}/payment/success?session_id={CHECKOUT_SESSION_ID}&plan_code=${planData.code}`,
        cancelUrl: `${window.location.origin}/payment/cancel`,
        webhookUrl: `${window.location.origin}/api/payments/stripe/webhook`
      };
      
  logger.debug('StripePaymentService - request payload:', requestPayload);
      
      const response = await api.post('/payments/stripe/create-link', requestPayload);
  logger.debug('StripePaymentService - backend response:', response.data);
  logger.debug('StripePaymentService - paymentUrl:', response.data.paymentUrl);
      
      if (!response.data.paymentUrl) {
  logger.error('Backend returned no payment URL:', response.data);
        return {
          success: false,
          error: response.data.error || 'No payment URL received from backend'
        };
      }
      
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
  logger.error('Error creating Stripe payment link:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to create payment link'
      };
    }
  },

  async getPaymentStatus(sessionId) {
    try {
      const response = await api.get(`/payments/stripe/status/${sessionId}`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
  logger.error('Error getting Stripe payment status:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to get payment status'
      };
    }
  },

  async getDirectPaymentStatus(sessionId) {
    try {
  logger.debug('Checking direct Stripe payment status for:', sessionId);
      const response = await api.get(`/payments/stripe/direct-status/${sessionId}`);
  logger.debug('Direct Stripe payment status result:', response.data);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
  logger.error('Error getting direct Stripe payment status:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to get direct payment status'
      };
    }
  },

  async activatePlan(planCode, sessionId) {
    try {
      const response = await api.post('/payments/stripe/activate-plan', {
        planCode: planCode,
        sessionId: sessionId
      });
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
  logger.error('Error activating Stripe plan:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to activate plan'
      };
    }
  },

  async getPaymentInfo(sessionId) {
    try {
      const response = await api.get(`/payments/stripe/info/${sessionId}`);
      return {
        success: true,
        data: response.data
      };
    } catch (error) {
  logger.error('Error getting Stripe payment info:', error);
      return {
        success: false,
        error: error.response?.data?.message || 'Failed to get payment info'
      };
    }
  }
};

export default stripePaymentService;
